module.exports = __webpack_public_path__ + "3e7a4dc9d866fda15331414a9072da97.svg";